<template>
  <header v-if="!route.meta.hideChrome" class="app-header safe-top">
    <div class="header-row">
      <RouterLink to="/" class="brand-home-link" aria-label="Go to Seeft home">
        <SeeftLogo />
      </RouterLink>
      <div class="header-actions">
        <button
          v-if="canInstall"
          type="button"
          class="install-button"
          @click="promptInstall"
        >
          Install
        </button>
        <ThemeToggle />
      </div>
    </div>
    <div class="stack">
      <p class="eyebrow">{{ eyebrow }}</p>
      <h1 class="page-title">{{ title }}</h1>
      <p class="lede">
        {{ body }}
      </p>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { RouterLink, useRoute } from "vue-router";
import SeeftLogo from "./SeeftLogo.vue";
import ThemeToggle from "./ThemeToggle.vue";
import { useInstallPrompt } from "../composables/useInstallPrompt";
import { useSessionStore } from "../stores/session";

const session = useSessionStore();
const route = useRoute();
const { canInstall, promptInstall } = useInstallPrompt();

const eyebrow = computed(() =>
  typeof route.meta.headerEyebrow === "string" ? route.meta.headerEyebrow : session.statusLabel
);

const title = computed(() =>
  typeof route.meta.headerTitle === "string"
    ? route.meta.headerTitle
    : "Rerank the results YouTube buries."
);

const body = computed(() =>
  typeof route.meta.headerBody === "string"
    ? route.meta.headerBody
    : "Search with less noise, scan the strongest candidates faster, and keep the weaker ones visible without letting them take over the screen."
);
</script>
